<script>
export default
{
	functional: true,

	props:
	{
		fluid:
		{
			type:    Boolean,
			default: false,
		},
	},

	render(h, { props, slots })
	{
		const $slots = slots()

		return h('div', { staticClass: 'page-wrapper my-3' }, [ h('div', { props, staticClass: 'container-xl' }, [ $slots.default ]) ])
	},
}
</script>